import { createSlice } from '@reduxjs/toolkit';

export interface PartnerProductInfo {
  id: string;
  name: string;
  requiresPartnerCode: boolean;
  requiresLicenceCode: boolean;
}

export interface RegistrationState {
  token: string | null;
  targetOrgId: string | null;
  email: string | null;
  organisationCreationCode: string | null;
  partnerProduct: PartnerProductInfo | null;
}

export const registrationSlice = createSlice({
  name: 'registration',
  initialState: {
    token: null,
    targetOrgId: null,
    email: null,
    organisationCreationCode: null,
    partnerProduct: null,
  } as RegistrationState,
  reducers: {
    setToken: (state, { payload }) => {
      state.token = payload;
    },
    setTargetOrgId: (state, { payload }) => {
      state.targetOrgId = payload;
    },
    setEmail: (state, { payload }) => {
      state.email = payload;
    },
    setOrganisationCreationCode: (state, { payload }) => {
      state.organisationCreationCode = payload;
    },
    setPartnerProduct: (state, { payload }) => {
      state.partnerProduct = payload;
    },
  },
});

export const {
  setToken,
  setTargetOrgId,
  setEmail,
  setOrganisationCreationCode,
  setPartnerProduct,
} = registrationSlice.actions;
export const getToken = (state: any) => state.registration.token || null;
export const getTargetOrgId = (state: any) =>
  state.registration.targetOrgId || null;
export const getEmail = (state: any) => state.registration.email || null;
export const getOrganisationCreationCode = (state: any) =>
  state.registration.organisationCreationCode || null;
export const getPartnerProduct = (state: any): PartnerProductInfo | null =>
  state.registration.partnerProduct || null;

export default registrationSlice.reducer;
